import { CargoType } from 'types/cargo';
import { getCargoTypeLabel } from './cargo-type-labels.ts';

export const getCargoTypeOptions = () =>
  Object.values(CargoType).map((type) => ({ value: type, label: getCargoTypeLabel(type) }));
